import styled, { css } from 'styled-components'
import { breakpoint } from 'utils'

import BaseIndexLayout, {
  Title as TitleUnstyled,
  Main,
} from 'components/IndexLayout'
import Heading from 'components/Heading'

export const BreadcrumbsWrapper = styled.div<{
  isOnboardingLicensesSignUpOn: boolean
}>`
  ${({ isOnboardingLicensesSignUpOn }) =>
    isOnboardingLicensesSignUpOn
      ? css`
          display: flex;
          justify-content: center;
        `
      : css`
          display: none;

          ${breakpoint('sm')`
            display: block;
            
            text-align: center;
            margin-top: 16px;

            + ${TitleUnstyled} {
              margin-top: 32px;
            }`}
        `}
`

export const IndexLayout = styled(BaseIndexLayout)<{ expand?: boolean }>`
  ${({ expand }) =>
    expand &&
    breakpoint('base', 'md')`
      padding-bottom: 234px;
    `}

  ${({ expand }) =>
    expand &&
    `
    ${Main} {
      max-width: 100%;
      margin-top: 66px;
  `}

  ${breakpoint('base', 'sm')`
      margin-top: 40px;
  `}
`

export const H1 = styled(Heading.H1)`
  text-align: center;
  margin: 32px 0 40px;
  font-size: ${({ theme }) => theme.fontSizes.xxlarge};
  line-height: 1.25;
`

export const H2 = styled(Heading.H2)`
  font-weight: 700;
  line-height: 1.6;
  margin-top: 0;
  margin-bottom: 4px;
`

export const Text = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.foreground.secondary[3]};
  margin: 0;
`
